import type { Application, Definition, ControllerConstructor } from '@hotwired/stimulus'

type ImportedModules = ReturnType<ImportMeta['glob']>;
type Entry<T> = { [K in keyof T]: [K, T[K]] }[keyof T]
type StimulusModule = { default: ControllerConstructor };

export const CONTROLLER_FILENAME_REGEX = /^.*\/(.+)(?:[/_-]controller\..+?)/

export function registerControllers(application: Application, controllerModules: ImportedModules) {
  const definitions = definitionsFromGlob(controllerModules);
  application.load(definitions)
}

function definitionsFromGlob(controllerModules: ImportedModules): Definition [] {
  return Object.entries(controllerModules).map(definitionFromEntry).filter(Boolean) as Definition[];
}

function isDefinition(module: unknown): module is StimulusModule {
  return (module as StimulusModule)?.default !== undefined
    && typeof (module as StimulusModule).default === "function";
}

function definitionFromEntry([name, controllerModule]: Entry<ImportedModules>): Definition | undefined {
  const identifier = identifierForGlobKey(name);

  if (identifier && isDefinition(controllerModule)) {
    const controllerConstructor = controllerModule.default;
    return { identifier, controllerConstructor };
  }
}

export function identifierForGlobKey(key: string): string | undefined {
  const logicalName = (key.match(CONTROLLER_FILENAME_REGEX) || [])[1]
  if (logicalName)
    return logicalName.replace(/_/g, '-').replace(/\//g, '--')
}
